import React from 'react';
import styles from '../styles/Team.module.css';

const ModernLoader = ({ message = "Loading data", size = "default" }) => {
  return (
    <div className={`${styles.modernLoadingContainer} ${styles[`modernLoading${size.charAt(0).toUpperCase() + size.slice(1)}`]}`}>
      <div className={styles.modernLoader}>
        {/* Neural Network Animation */}
        <div className={styles.neuralNetwork}>
          <div className={styles.neuralNode}></div>
          <div className={styles.neuralNode}></div>
          <div className={styles.neuralNode}></div>
          <div className={styles.neuralNode}></div>
          <div className={styles.neuralNode}></div>
          <div className={styles.neuralNode}></div>
        </div>
        
        {/* AI Processing Bars */}
        <div className={styles.processingBars}>
          <div className={styles.processingBar}></div>
          <div className={styles.processingBar}></div>
          <div className={styles.processingBar}></div>
          <div className={styles.processingBar}></div>
          <div className={styles.processingBar}></div>
        </div>
        
        {/* Pulsing Orb */}
        <div className={styles.pulsingOrb}>
          <div className={styles.orbCore}></div>
          <div className={styles.orbRing}></div>
          <div className={styles.orbRing}></div>
        </div>
      </div>
      
      {/* Optional Message */}
      {message && (
        <div className={styles.loadingMessage}>
          <span className={styles.loadingText}>{message}</span>
          <div className={styles.loadingDots}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModernLoader;
